import React from 'react';
import { put, call } from 'redux-saga/effects';
// import { getCurrentUser, saveCurrentUser, logout } from './actions'
// import { GET_CURRENT_USER, LOGOUT } from './actionTypes'
import { RECEIVER_OFFLINE, RTM_NOTIFY_USER_SUBSCRIBE } from './actionTypes';
import io from 'socket.io-client';
import * as actions from './actions';
import { message, notification } from 'antd';

const isTenantMode = process.env.APP_MODE === 'tenant';
const handlers = {
  conv_created: actions.convCreated,
  order_updated: actions.orderUpdated,
  order_message: actions.orderMessage,
  working_state_changed: actions.managerWorkingStateChanged,
  receiver_offline: actions.receiverOffline,
  notify_center_message: actions.notifyCenterMessage,
  user_subscribe: actions.userSubscribe,
  task_refresh: actions.taskRefresh,
  conv_refresh: actions.convRefresh,
  todo_refresh: actions.todoRefresh,
  chaoshi_refresh: actions.chaoshiRefresh,
  reply_refresh: actions.replyRefresh,
};

let socket;
let hideGlobalTips;
let tipsLock;
let timer;

export function initialize({ dispatch }) {
  const token = localStorage.getItem(`xb_${process.env.APP_MODE}_token`);
  socket = io(process.env.API_PREFIX, {
    path: '/ws',
    transports: ['websocket', 'polling'],
    forceNew: true,
    query: 'token=' + token,
  });
  let isFirstConnect = true;

  socket
    .on('connect', () => {
      socket.emit('common', {
        event: 'checkSingleInstance',
        type: process.env.APP_MODE,
        isFirstConnect,
      });
      isFirstConnect = false;
      console.log('client connected, socket.id:', socket.id);
    })
    .on('disconnect', () => {
      console.log('网络断开');
    })
    .on('reconnecting', () => {
      if (tipsLock) {
        return;
      }

      tipsLock = true;

      timer = setTimeout(() => {
        hideGlobalTips = message.loading('网络已断开，请检查您的网络', 0);
      }, 1000 * 30);
    })
    .on('reconnect', () => {
      try {
        hideGlobalTips();
      } catch (e) { }

      tipsLock = null;
      clearTimeout(timer);
      message.success('网络已恢复', 1);
    })
    .on('error', function (error) {
      if (error.type == 'UnauthorizedError' || error.code == 'invalid_token') {
        console.log("User's token has expired");
      }
    });

  Object.entries(handlers).forEach(([type, handler]) =>
    socket.on(type, (event) => {
      dispatch(handler(event));
    })
  );
}

export default {
  *[RECEIVER_OFFLINE]() {
    // message.info(
    //   <div style={{ paddingLeft: 20 }}>
    //     客服不在线，如有急事请拨打 151-4726-8423
    //   </div>,
    //   3
    // );
  },
  *[RTM_NOTIFY_USER_SUBSCRIBE]() {
    //notification.close('qrcode');
    window.location.reload();
    //message.info('感谢关注，请扫码完成登陆注册');
  },
};

// export default {
//   *[GET_CURRENT_USER]() {
//     const user = yield call(services.getCurrentUser)

//     if (
//       (process.env.APP_MODE === 'tenant' && !user.staff) ||
//       ( process.env.APP_MODE === 'manager' && !user.manager )) {
//       alert('无权限')
//       yield put(logout())
//     } else {
//       yield put(saveCurrentUser(user))
//     }
//   },

//   *[LOGOUT]() {
//     localStorage.removeItem(`xb_${process.env.APP_MODE}_token`)
//     window.location.reload()
//   }
// }
